import { render, staticRenderFns } from "./RelatorioView.vue?vue&type=template&id=2c45a2ac&"
import script from "./RelatorioView.vue?vue&type=script&lang=js&"
export * from "./RelatorioView.vue?vue&type=script&lang=js&"
import style0 from "./RelatorioView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports